export const Cart_table = "Cart";
export const Notifications_table = "Notifications";
export const Cart_duplicate = "Cart_duplicate";

export const Products_table = "Products";